//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { PurchaseOption } from '@apis/campaign-requests/sampling/opportunities/samplingOpportunitiesApiModel';
import { SortDir } from '@apis/campaign-requests/shared/Sorting';
import { PurchaseOptionsProvider } from '@campaigns/components/shared/purchase-options/PurchaseOptionsContext';
import { PurchaseOptionsTable } from '@campaigns/components/shared/purchase-options/PurchaseOptionsTable';
import { PurchaseOptionsSortKey } from '@campaigns/constants/sampling/SamplingCampaignRequestConstants';
import { BodyText, LabelText, SubtitleText } from '@components/atoms/text/Text';

interface ExpiredPurchaseOptionsTableProps {
  expiredSelectedOptions: PurchaseOption[];
  title?: string;
}

export const ExpiredPurchaseOptionsTable = ({
  expiredSelectedOptions,
  title,
}: ExpiredPurchaseOptionsTableProps) => {
  return (
    <ExpiredWarningContainer>
      <HeaderContainer>
        {title && <SubtitleText>{title}</SubtitleText>}
        <BodyText>
          The previously selected purchase item is no longer active
        </BodyText>
      </HeaderContainer>
      <TableContainer>
        <LabelText>Previously Selected Purchase</LabelText>
        <PurchaseOptionsProvider readOnly={true}>
          <PurchaseOptionsTable
            onSortChange={() => undefined}
            purchaseOptions={expiredSelectedOptions}
            sortDir={SortDir.ASC}
            sortKey={PurchaseOptionsSortKey.EXPIRY_DATE}
          />
        </PurchaseOptionsProvider>
      </TableContainer>
    </ExpiredWarningContainer>
  );
};

const ExpiredWarningContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacings[3]};
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacings[0]};
`;

const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacings[1]};
  width: 100%;
  padding-bottom: ${({ theme }) => theme.spacings[3]};
`;
